import { createSelector } from "reselect";

export const userActionSelector = createSelector(
    state => state.services.userAction,
    state => state
);